import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatComposerDefaultVariants = {
  "variant": "default",
  "elevation": "raised"
}
const chatComposerCompoundVariants = []

const chatComposerSlotNames = [
  [
    "root",
    "chatComposer__root"
  ],
  [
    "surface",
    "chatComposer__surface"
  ],
  [
    "header",
    "chatComposer__header"
  ],
  [
    "input",
    "chatComposer__input"
  ],
  [
    "footer",
    "chatComposer__footer"
  ],
  [
    "leadingActions",
    "chatComposer__leadingActions"
  ],
  [
    "trailingActions",
    "chatComposer__trailingActions"
  ],
  [
    "status",
    "chatComposer__status"
  ],
  [
    "drawer",
    "chatComposer__drawer"
  ],
  [
    "drawerTrigger",
    "chatComposer__drawerTrigger"
  ],
  [
    "drawerSummary",
    "chatComposer__drawerSummary"
  ],
  [
    "drawerCount",
    "chatComposer__drawerCount"
  ],
  [
    "drawerChevron",
    "chatComposer__drawerChevron"
  ],
  [
    "drawerContentGrid",
    "chatComposer__drawerContentGrid"
  ],
  [
    "drawerContent",
    "chatComposer__drawerContent"
  ],
  [
    "queue",
    "chatComposer__queue"
  ],
  [
    "queueItem",
    "chatComposer__queueItem"
  ],
  [
    "queueText",
    "chatComposer__queueText"
  ],
  [
    "queueActions",
    "chatComposer__queueActions"
  ],
  [
    "attachmentDropzone",
    "chatComposer__attachmentDropzone"
  ],
  [
    "attachmentDropzoneOverlay",
    "chatComposer__attachmentDropzoneOverlay"
  ],
  [
    "attachmentDropzoneHint",
    "chatComposer__attachmentDropzoneHint"
  ]
]
const chatComposerSlotFns = /* @__PURE__ */ chatComposerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatComposerDefaultVariants, getSlotCompoundVariant(chatComposerCompoundVariants, slotName))])

const chatComposerFn = memo((props = {}) => {
  return Object.fromEntries(chatComposerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatComposerVariantKeys = [
  "elevation",
  "variant",
  "severity"
]
const getVariantProps = (variants) => ({ ...chatComposerDefaultVariants, ...compact(variants) })

export const chatComposer = /* @__PURE__ */ Object.assign(chatComposerFn, {
  __recipe__: false,
  __name__: 'chatComposer',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatComposerVariantKeys,
  variantMap: {
  "elevation": [
    "raised",
    "flat"
  ],
  "variant": [
    "default",
    "edit"
  ],
  "severity": [
    "error",
    "warning"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatComposerVariantKeys)
  },
  getVariantProps
})